
import Vue from "vue";
import highlighter from "vue-highlight-words";
import { mapState } from "vuex";
import groupBy from "lodash/groupBy";
import Oa from "../../../store/planner/objetive/Oa";
import { orderBy } from "lodash";
import UnitPlanComments from "../../../store/units/UnitPlanComments";
import RomaMessageModal from "../../commons/RomaMessageModal.vue";
import moment from "moment";
import { MoreVerticalIcon, MessageCircleIcon } from 'vue-feather-icons';

Vue.filter("formatDate", function (value) {
  if (value) {
    return moment(String(value)).format("DD/MM");
  }
});

export default Vue.extend({
  name: "RomaActivity",
  props: {
    unit: {
      type: Object,
      required: true,
    },
    activity: {
      type: Object,
      required: true,
    },
    color: {
      type: String,
      default: "grey",
    },
    opened: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      userId: this.$store.state.user.userId,
      userPrivileges: this.$store.state.user.privileges,
      isUTP: this.$store.state.user.isUTP,
      filterBy: {
        field: "",
        value: 0,
      },
      parcialRequest: {
        idPlanUnidadActividad: 0,
        idPlanUnidad: 0,
      },
      messageDialog: false,
    };
  },
  computed: {
    ...mapState({
      highlightWords(state) {
        return state.highlight.split(" ");
      },
    }),
  },
  methods: {
    addComment(activity: any, event: any) {
      event.stopPropagation();
      this.messageDialog = true;
      this.parcialRequest = {
        idPlanUnidadActividad: activity.id,
        idPlanUnidad: this.unit.id,
      };
      this.filterBy = {
        field: "idPlanUnidadActividad",
        value: activity.id,
      };
    },
    editActivity(activity: Object) {
      this.$emit("edit", activity);
    },
    goDelActivity(activity: object) {
      this.$emit("delete", activity);
    },
    getLocaleDate(value:any){
      return moment(value).locale("es");
    },
    commentsCount(activity: any): number {
      return UnitPlanComments.query()
        .where("idPlanUnidadActividad", activity.id)
        .count();
    },
    groupByOa(ies) {
      const oas = groupBy(ies, (n) => {
        return n.oa_id;
      });
      return orderBy(Oa.findIn(Object.keys(oas)), ["cod"]);
    },
  },
  components: {
    highlighter,
    RomaMessageModal,
    MoreVerticalIcon,
    MessageCircleIcon
  },
});
